import type { DispensingRx } from '@/features/admin-v2/api';
import { AllergyList } from '@/pages/patients/AllergyList';

/**
 * RL-1159: the patient's allergies on the dispensary detail, from
 * `patient.allergyDetails` (RL-1171): patient-reported ones marked as not
 * confirmed, merged-record ones with the record they come from. Falls back to
 * the `patient.allergies` labels when the details are absent. RL-1156: drawn
 * by the shared AllergyList (read only here).
 */
export function DispensaryAllergies({
  patient,
}: {
  patient: DispensingRx['patient'];
}) {
  return (
    <AllergyList
      allergies={
        patient.allergyDetails ??
        patient.allergies.map((substance) => ({ substance }))
      }
    />
  );
}
